var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-table-simple",
    {
      staticStyle: { "max-height": "65vh", "font-size": "12px" },
      attrs: { bordered: "", responsive: "", "sticky-header": "" },
    },
    [
      _c("colgroup", [
        _c("col", { staticStyle: { width: "90px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "250px" } }),
        _c("col", { staticStyle: { width: "130px" } }),
        _c("col", { staticStyle: { width: "130px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "150px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _vm._v("`` "),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "160px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "110px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "130px" } }),
      ]),
      _c(
        "b-thead",
        { attrs: { "head-variant": "light" } },
        [
          _c(
            "b-tr",
            [
              _c("b-th", { attrs: { rowspan: "2" } }, [_vm._v("ID")]),
              _c("b-th", { attrs: { rowspan: "2" } }, [_vm._v("제약사")]),
              _c("b-th", { attrs: { rowspan: "2" } }, [_vm._v("제품명")]),
              _c("b-th", { attrs: { rowspan: "2" } }, [_vm._v("청구코드")]),
              _c("b-th", { attrs: { rowspan: "2" } }, [_vm._v("지역")]),
              _c("b-th", { attrs: { rowspan: "2" } }, [_vm._v("게시 기간")]),
              _c("b-th", { attrs: { rowspan: "2" } }, [_vm._v("진료과")]),
              _c("b-th", { attrs: { rowspan: "2" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "전체처수" : "전체수")),
              ]),
              _c("b-th", { attrs: { rowspan: "2" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "요양기관수" : "의사수")),
              ]),
              _c("b-th", { attrs: { rowspan: "2" } }, [
                _vm._v(
                  _vm._s(_vm.searchType === 2 ? "기등록처수" : "기등록수")
                ),
              ]),
              _c("b-th", {
                attrs: { rowspan: "2" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.searchType === 2
                      ? "노출처수<br/>(닥터인포)"
                      : "노출수<br/>(닥터인포)"
                  ),
                },
              }),
              _c("b-th", { attrs: { colspan: "3" } }, [
                _vm._v("메인 간편처방등록"),
              ]),
              _c("b-th", { attrs: { colspan: "3" } }, [
                _vm._v("메인 텍스트배너"),
              ]),
              _c("b-th", { attrs: { colspan: "5" } }, [_vm._v("처방팝업")]),
              _c("b-th", { attrs: { colspan: "6" } }, [_vm._v("진료후팝업")]),
              _c("b-th", {
                attrs: { rowspan: "2" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.searchType === 2
                      ? "등록처수<br/>(기초자료)"
                      : "등록수<br/>(기초자료)"
                  ),
                },
              }),
              _c("b-th", { attrs: { rowspan: "2" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "잔여처수" : "잔여수")),
              ]),
              _c("b-th", { attrs: { rowspan: "2" } }, [
                _vm._v("게시 잔여기간"),
              ]),
            ],
            1
          ),
          _c(
            "b-tr",
            [
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v("클릭수"),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "클릭처수" : "클릭명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "등록처수" : "등록명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v("클릭수"),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "클릭처수" : "클릭명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "등록처수" : "등록명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v("노출수"),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "노출처수" : "노출명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v("클릭수"),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "클릭처수" : "클릭명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "등록처수" : "등록명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v("노출 기간"),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v("노출수"),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "노출처수" : "노출명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v("클릭수"),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "클릭처수" : "클릭명수")),
              ]),
              _c("b-th", { staticStyle: { top: "38.55px" } }, [
                _vm._v(_vm._s(_vm.searchType === 2 ? "등록처수" : "등록명수")),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tbody",
        [
          _vm._l(_vm.data, function (cumulative) {
            return [
              _vm._l(cumulative.landingDepts, function (dept, index) {
                return [
                  _c(
                    "b-tr",
                    {
                      key:
                        "cumulative-" +
                        cumulative.regionName +
                        "-" +
                        cumulative.liveInfoId +
                        "-" +
                        index,
                      style:
                        cumulative.region === 9999
                          ? "background-color: rgba(127, 127, 255, 0.1);"
                          : "",
                    },
                    [
                      index === 0
                        ? _c(
                            "b-td",
                            {
                              attrs: {
                                rowspan: cumulative.landingDepts.length + 1,
                              },
                            },
                            [_vm._v(" " + _vm._s(cumulative.liveInfoId) + " ")]
                          )
                        : _vm._e(),
                      index === 0
                        ? _c(
                            "b-td",
                            {
                              attrs: {
                                rowspan: cumulative.landingDepts.length + 1,
                              },
                            },
                            [_vm._v(" " + _vm._s(cumulative.clientName) + " ")]
                          )
                        : _vm._e(),
                      index === 0
                        ? _c(
                            "b-td",
                            {
                              attrs: {
                                rowspan: cumulative.landingDepts.length + 1,
                              },
                            },
                            [_vm._v(" " + _vm._s(cumulative.drugName) + " ")]
                          )
                        : _vm._e(),
                      index === 0
                        ? _c(
                            "b-td",
                            {
                              attrs: {
                                rowspan: cumulative.landingDepts.length + 1,
                              },
                            },
                            [_vm._v(" " + _vm._s(cumulative.cgCode) + " ")]
                          )
                        : _vm._e(),
                      index === 0
                        ? _c(
                            "b-td",
                            {
                              attrs: {
                                rowspan: cumulative.landingDepts.length + 1,
                              },
                            },
                            [_vm._v(" " + _vm._s(cumulative.regionName) + " ")]
                          )
                        : _vm._e(),
                      index === 0
                        ? _c(
                            "b-td",
                            {
                              attrs: {
                                rowspan: cumulative.landingDepts.length + 1,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("$dateFormatter")(
                                      cumulative.startDate,
                                      "MM월 DD일"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("br"),
                              _vm._v(
                                "~ " +
                                  _vm._s(
                                    _vm._f("$dateFormatter")(
                                      cumulative.endDate,
                                      "MM월 DD일"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("b-td", [_vm._v(_vm._s(dept.medicalDeptName))]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.wasRegCount + dept.unRegCountDr
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(_vm._f("$numberFormatter")(dept.uniqueCount))
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(_vm._f("$numberFormatter")(dept.wasRegCount))
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(_vm._f("$numberFormatter")(dept.unRegCountDr))
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(dept.totalClickCountDr)
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(dept.groupClickCountDr)
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(dept.landingRegCountDr)
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.totalClickCountTextBn
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.groupClickCountTextBn
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.landingRegCountTextBn
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(dept.totalShowCountPopup)
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(dept.groupShowCountPopup)
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.totalClickCountPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.groupClickCountPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.landingRegCountPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(_vm._s(dept.afterConsultPopupPeriod)),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.totalShowCountAfterConsultPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.groupShowCountAfterConsultPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.totalClickCountAfterConsultPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.groupClickCountAfterConsultPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.landingRegCountAfterConsultPopup
                            )
                          ) + " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(_vm._f("$numberFormatter")(dept.ysrRegCount)) +
                            " "
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              dept.unRegCountDr -
                                (dept.landingRegCountDr +
                                  dept.landingRegCountTextBn +
                                  dept.landingRegCountPopup +
                                  dept.landingRegCountAfterConsultPopup +
                                  dept.ysrRegCount)
                            )
                          ) + " "
                        ),
                      ]),
                      index === 0
                        ? _c(
                            "b-td",
                            {
                              attrs: {
                                rowspan: cumulative.landingDepts.length,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getRemainDate(cumulative.endDateStr) +
                                      "일"
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              }),
              _c(
                "b-tr",
                {
                  key:
                    "cumulative-" +
                    cumulative.regionName +
                    "-" +
                    cumulative.liveInfoId +
                    "-subtotal",
                  style:
                    cumulative.subTotal.medicalDeptName === "소계"
                      ? "background-color: rgba(127, 127, 127, 0.1);"
                      : "",
                },
                [
                  _c("b-td", [
                    _vm._v(_vm._s(cumulative.subTotal.medicalDeptName)),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.wasRegCount +
                            cumulative.subTotal.unRegCountDr
                        )
                      )
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.uniqueCount
                        )
                      )
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.wasRegCount
                        )
                      )
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.unRegCountDr
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.totalClickCountDr
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.groupClickCountDr
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.landingRegCountDr
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.totalClickCountTextBn
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.groupClickCountTextBn
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.landingRegCountTextBn
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.totalShowCountPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.groupShowCountPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.totalClickCountPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.groupClickCountPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.landingRegCountPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td"),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.totalShowCountAfterConsultPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.groupShowCountAfterConsultPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.totalClickCountAfterConsultPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.groupClickCountAfterConsultPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.landingRegCountAfterConsultPopup
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.ysrRegCount
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("$numberFormatter")(
                          cumulative.subTotal.unRegCountDr -
                            (cumulative.subTotal.landingRegCountDr +
                              cumulative.subTotal.landingRegCountTextBn +
                              cumulative.subTotal.landingRegCountPopup +
                              cumulative.subTotal
                                .landingRegCountAfterConsultPopup +
                              cumulative.subTotal.ysrRegCount)
                        )
                      ) + " "
                    ),
                  ]),
                  _c("b-td"),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }